import type { GetProjectComments200Page } from './getProjectComments200Page';

/**
 * 프로젝트 댓글 목록 응답 데이터
 */
export type GetProjectComments200 = {
  /** 응답 코드 (성공 또는 에러 식별) */
  code?: string;
  /** 응답 메시지 */
  message?: string;
  page?: GetProjectComments200Page;
  success?: boolean;
};
